import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { ElementType } from 'react'

interface ContainerProps {
  as?: ElementType
}

export const Container = styled.form<ContainerProps>`
  flex: 0 1 700px;
`

export const InfoWrapper = styled.div`
  margin-bottom: ${Spacing.S16};
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

export const ThumbnailFormatterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  padding: ${Spacing.S12};
  border: 1px solid ${Color.Grey150};
  background-color: white;
`
